import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_EMPTY_FIRST_NAME = "empty_first_name";
export const ERROR_EMPTY_LAST_NAME = "empty_last_name";
export const ERROR_BAD_FORMAT_WORK_PHONE = "work_phone_bad_format";
export const ERROR_BAD_FORMAT_CELL_PHONE = "cell_phone_bad_format";
export const ERROR_BAD_FORMAT_HOME_PHONE = "home_phone_bad_format";
export const ERROR_EMPTY_REGION = "empty_region";
export const ERROR_SOMETHING_WENT_WRONG = "something_went_wrong";
export const ERROR_EMPTY_WORK_PHONE_PRIORITY = "empty_work_phone_priority";
export const ERROR_EMPTY_CELL_PHONE_PRIORITY = "empty_cell_phone_priority";
export const ERROR_EMPTY_HOME_PHONE_PRIORITY = "empty_home_phone_priority";

export default formWithMessages(props => {
  const { engineer, regions, onSave, disabled } = props;
  return (
    <Form
      formProps={{
        id: `engineer-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...props.messagesProps}
      fields={{
        firstName: {
          uiProps: {
            type: "text",
            placeholder: "First name",
            autoFocus: true,
            maxLength: 20,
          },
          position: 1,
          initialValue: engineer.firstName,
          label: "First name ",
        },
        lastName: {
          uiProps: {
            type: "text",
            placeholder: "Last name",
            maxLength: 20,
          },
          position: 2,
          initialValue: engineer.lastName,
          label: "Last name ",
        },
        workPhone: {
          uiProps: {
            type: "text",
            placeholder: "Work phone",
            maxLength: 10,
          },
          position: 3,
          initialValue: engineer.workPhone,
          label: "Work phone ",
          onChange: newPhone => newPhone.replace(/\D/g, ""),
          colsWidth: 6,
        },
        workPhonePriority: {
          uiProps: {
            type: "select",
            options: [
              { id: 1, name: 1 },
              { id: 2, name: 2 },
              { id: 3, name: 3 },
            ],
          },
          position: 3,
          initialValue: engineer.workPhonePriority,
          label: "Priority ",
          hoverHelp: () => "Select the priority for the work phone number.",
          colsWidth: 6,
        },
        cellPhone: {
          uiProps: {
            type: "text",
            placeholder: "Cell phone",
            maxLength: 10,
          },
          position: 4,
          initialValue: engineer.cellPhone,
          label: "Cell phone ",
          onChange: newPhone => newPhone.replace(/\D/g, ""),
          colsWidth: 6,
        },
        cellPhonePriority: {
          uiProps: {
            type: "select",
            options: [
              { id: 1, name: 1 },
              { id: 2, name: 2 },
              { id: 3, name: 3 },
            ],
          },
          position: 4,
          initialValue: engineer.cellPhonePriority,
          label: "Priority ",
          hoverHelp: () => "Select the priority for the cell phone number.",
          colsWidth: 6,
        },
        homePhone: {
          uiProps: {
            type: "text",
            placeholder: "Home phone",
            maxLength: 10,
          },
          position: 5,
          initialValue: engineer.homePhone,
          label: "Home phone ",
          onChange: newPhone => newPhone.replace(/\D/g, ""),
          colsWidth: 6,
        },
        homePhonePriority: {
          uiProps: {
            type: "select",
            options: [
              { id: 1, name: 1 },
              { id: 2, name: 2 },
              { id: 3, name: 3 },
            ],
          },
          position: 5,
          initialValue: engineer.homePhonePriority,
          label: "Priority ",
          hoverHelp: () => "Select the priority for the home phone number.",
          colsWidth: 6,
        },
        regionId: {
          uiProps: {
            type: "select",
            options: regions,
          },
          position: 6,
          initialValue: engineer.regionId,
          label: "Region ",
          hoverHelp: () =>
            "Select the Region to which this Engineer should be assigned. Engineers may only be assigned to one Region.",
        },
        enabled: {
          uiProps: {
            type: "checkbox",
          },
          position: 7,
          initialValue: engineer.enabled,
          label: "Enabled ",
          hoverHelp: () =>
            "Uncheck this box to disable this Engineer. This will hide the Engineer throughout your OCS system, and remove all of their shifts from the on-call schedule.",
        },
      }}
      validation={formData => {
        if (!formData.firstName) return ERROR_EMPTY_FIRST_NAME;
        if (!formData.lastName) return ERROR_EMPTY_LAST_NAME;
        if (formData.workPhone.length !== 10)
          return ERROR_BAD_FORMAT_WORK_PHONE;
        if (formData.workPhonePriority === "-1")
          return ERROR_EMPTY_WORK_PHONE_PRIORITY;
        if (formData.cellPhone.length !== 10)
          return ERROR_BAD_FORMAT_CELL_PHONE;
        if (formData.cellPhonePriority === "-1")
          return ERROR_EMPTY_CELL_PHONE_PRIORITY;
        if (formData.homePhone.length !== 10)
          return ERROR_BAD_FORMAT_HOME_PHONE;
        if (formData.homePhonePriority === "-1")
          return ERROR_EMPTY_HOME_PHONE_PRIORITY;
        if (formData.regionId === "-1") return ERROR_EMPTY_REGION;
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY_FIRST_NAME]: "First name can't be empty",
        [ERROR_EMPTY_LAST_NAME]: "Last name can't be empty",
        [ERROR_BAD_FORMAT_WORK_PHONE]:
          "Work phone must be a phone number (10 digits)",
        [ERROR_BAD_FORMAT_CELL_PHONE]:
          "Cell phone must be a phone number (10 digits)",
        [ERROR_BAD_FORMAT_HOME_PHONE]:
          "Home phone must be a phone number (10 digits)",
        [ERROR_EMPTY_REGION]: "Pick a region!",
        [ERROR_SOMETHING_WENT_WRONG]: "Something went wrong please try again!",
        [ERROR_EMPTY_WORK_PHONE_PRIORITY]: "Pick a priority for work phone",
        [ERROR_EMPTY_CELL_PHONE_PRIORITY]: "Pick a priority for cell phone",
        [ERROR_EMPTY_HOME_PHONE_PRIORITY]: "Pick a priority for home phone",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/Engineer.js